const lt = {
  cmd: {
    placeholder: 'Ieškoti puslapių, veiksmų…',
    noResults: 'Nieko nerasta',
    navigate: 'judejimas',
    select: 'pasirinkti',
    close: 'uzdaryti',
  },

  // App
  app: {
    name: 'A5Suite',
    loading: 'Kraunama...',
  },

  // Auth
  auth: {
    username: 'Naudotojo vardas',
    password: 'Slaptažodis',
    signIn: 'Prisijungti',
    signingIn: 'Prisijungiama...',
    loginFailed: 'Prisijungimas nepavyko',
    signOut: 'Atsijungti',
  },

  // Profile (header identity chip)
  profile: {
    title: 'Paskyra',
    manage: 'Paskyra — integravizija.lt',
    role: {
      admin: 'Administratorius',
      seniorAccountant: 'Vyr. apskaitininkas',
      accountant: 'Apskaitininkas',
      viewer: 'Stebėtojas',
    },
  },

  // Navigation
  nav: {
    dashboard: 'Prietaisų skydelis',
    darbai: "Darbai",
    myFindings: 'Mano užklausos',
    invoices: 'Sąskaitos',
    portfolio: 'Visos įmonės',
    documents: 'Dokumentai',
    users: 'Naudotojai',
    closeWizard: 'Uždarymas',
    automation: 'Automatizavimas',
    analytics: 'Analitika',
    sales: 'Pardavimai',
    purchases: 'Pirkimai',
    bankingCash: 'Bankas ir kasa',
    journal: 'Žurnalas',
    assets: 'Ilgalaikis turtas',
    reports: 'Ataskaitos',
    taxCompliance: 'Mokesčiai ir atitiktis',
    close: 'Uždaryti',
    setup: 'Nuostatos',
    accounts: 'Sąskaitų planas',
    contacts: 'Kontaktai',
    shares: 'Akcijos',
    catalog: 'Katalogas',
    aiAudit: 'AI ir auditas',
    arena: 'Agentų arena',
    findings: 'Užklausų vykdymas',
    settings: 'Nustatymai',
    inventory: 'Atsargos',
    inventoryList: 'Atsargų likučiai',
    payroll: 'Darbo užmokestis',
    advanceReports: 'Avansinės ataskaitos',
    adminOnly: 'Tik administratoriui',
    modules: 'Moduliai',
  },

  // Common
  common: {
    save: 'Išsaugoti',
    saving: 'Saugoma...',
    create: 'Sukurti',
    cancel: 'Atšaukti',
    edit: 'Redaguoti',
    delete: 'Ištrinti',
    close: 'Uždaryti',
    back: 'Atgal',
    toStart: 'Į pradžią',
    search: 'Paieška',
    searchPlaceholder: 'Ieškoti pagal turinį, dokumento nr...',
    from: 'Nuo',
    to: 'Iki',
    date: 'Data',
    name: 'Pavadinimas',
    code: 'Kodas',
    type: 'Tipas',
    status: 'Būsena',
    actions: 'Veiksmai',
    loading: 'Kraunama...',
    noData: 'Nėra duomenų',
    confirm: 'Patvirtinti',
    yes: 'Taip',
    no: 'Ne',
    active: 'Aktyvus',
    obsolete: 'Nenaudojamas',
    manage: 'Valdyti',
    viewAll: 'Žiūrėti visus',
    details: 'Išsamiau',
    dateFrom: 'Galioja nuo',
    dateTo: 'Galioja iki',
    person: 'Asmuo',
    content: 'Turinys',
    amount: 'Suma',
    currency: 'Valiuta',
    total: 'Viso',
    description: 'Aprašymas',
    none: '-- Nėra --',
    noPerson: 'Be asmens',
    account: 'Sąskaita',
    accountName: 'Sąskaitos pavadinimas',
    docNumber: 'Dokumento nr.',
    docType: 'Dokumento tipas',
    tryAgain: 'Bandyti dar kartą',
    done: 'Atlikta',
    preview: 'Peržiūra',
    required: '* Būtinas',
    language: 'Kalba',
    unknownError: 'Nežinoma klaida',
    update: 'Atnaujinti',
    unsavedChangesTitle: 'Neišsaugoti pakeitimai',
    unsavedChangesBody: 'Ar tikrai norite išeiti? Neišsaugoti pakeitimai bus prarasti.',
    leave: 'Išeiti',
    stay: 'Likti',
  },

  // Layout
  layout: {
    workspaceSwitchFailed: 'Nepavyko perjungti įmonės',
    noWorkspace: 'Nėra aktyvios darbo srities',
    createOrImport: 'Sukurkite arba importuokite darbo sritį, kad pradėtumėte dirbti su apskaitos duomenimis.',
    manageWorkspaces: 'Valdyti darbo sritis',
    workspaces: 'Darbo sritys',
    company: 'Įmonė',
    area: 'Sritis',
    readOnly: 'Tik skaitymo režimas',
    searchCtrlK: 'Paieška (Ctrl+K)',
    moduleLoading: 'Kraunamas modulis...',
  },

  // Workspace
  workspace: {
    title: 'Darbo sritys',
    createNew: 'Sukurti naują',
    noWorkspaces: 'Kol kas nėra darbo sričių — jos atsiras automatiškai prisijungus per integravizija.lt',
  },

  // My findings (user ticket view)
  myFindings: {
    title: 'Mano užklausos',
    empty: 'Kol kas jokių užklausų.',
    emptyHint: 'Prašymai, registruojami pokalbyje su asistentu, atsiranda čia iškart (kai kuriuos — patvirtinkite pokalbyje).',
    loadError: 'Nepavyko įkelti užklausų.',
    loadErrorHint: 'Atsinaujinkite puslapį arba pabandykite vėliau — užklausos neišnyko.',
    newRequest: 'Nauja užklausa',
    newRequestPrompt: 'Noriu pranešti apie problemą arba pasiūlyti pagerinimą. Paklauskite manęs, kas nutiko ar ką norėčiau pagerinti, ir užregistruokite užklausą.',
    view: 'Peržiūrėti',
    edit: 'Redaguoti',
    addNote: 'Pridėti pastabą',
    notesTitle: 'Mano pastabos',
    notesEmpty: 'Pastabų kol kas nėra.',
    notesPlaceholder: 'Jūsų pastabos apie šią užklausą…',
    notesSaveError: 'Nepavyko išsaugoti pastabų.',
    notesTooLong: 'Pastabos per ilgos (iki 4000 simbolių).',
    descriptionTitle: 'Aprašymas',
    suggestedFixTitle: 'Pasiūlytas sprendimas',
    documentRef: 'Dokumentas',
    reportersJoined: 'Dar pranešė {{count}} žmogus(-ės) — pastabos sujungtos, būsena bendra',
    close: 'Uždaryti',
  },

  // Dashboard
  dashboard: {
    code: 'Kodas',
    vat: 'PVM',
    invoice: '+ Sąskaita faktūra',
    journalBtn: 'Žurnalas',
    closeReadiness: 'Uždarymo pasirengimas',
    cashPosition: 'Pinigų padėtis',
    anomaliesRisk: 'Anomalijos ir rizika',
    banking: 'Bankas',
    critical: 'kritinių',
    warnings: 'įspėjimų',
    info: 'informacinių',
    allClear: 'Viskas tvarkoje',
    noAnomalies: 'Anomalijų nerasta',
    totalDecisions: 'iš viso sprendimų',
    recentJournal: 'Paskiausi žurnalo įrašai',
    recentInvoices: 'Paskiausios sąskaitos faktūros',
    trialBalance: 'Bandomasis balansas',
    asOfToday: 'Šiandienos',
    vatSummary: 'PVM suvestinė',
    taxReports: 'Mokesčių ataskaitos',
    saftExport: 'SAFT eksportas',
    xmlForVmi: 'XML VMI',
    settingsBtn: 'Nustatymai',
    companyAndAccounts: 'Įmonė ir sąskaitos',
    accounts: 'Sąskaitos',
    trialBalanceItems: 'Bandomojo balanso įrašai',
    invoicesMade: 'Sąskaitos faktūros (Išrašytos)',
    debit: 'Debetas',
    credit: 'Kreditas',
    class: 'Klasė',
    longTermAssets: 'Ilgalaikis turtas',
    shortTermAssets: 'Trumpalaikis turtas',
    equity: 'Nuosavas kapitalas',
    liabilities: 'Įsipareigojimai',
    sales: 'Pardavimai',
    costs: 'Sąnaudos',
    noEntries: 'Nėra įrašų',
    noInvoices: 'Nėra sąskaitų faktūrų',
    ar: 'Gautinos sumos',
    ap: 'Mokėtinos sumos',
    out: 'IŠ',
    in: 'Į',
    decisionLog: 'Sprendimų žurnalas',
  },

  // Invoices
  invoices: {
    salesTitle: 'Pardavimo sąskaitos faktūros (Išrašytos)',
    purchaseTitle: 'Pirkimo sąskaitos faktūros (Gautos)',
    newInvoice: '+ Nauja sąskaita faktūra',
    salesTab: 'Pardavimai (Išrašytos)',
    scanTab: 'Skenavimas',
    templateTab: 'Šablonas',
    readOnlyHint: 'Ši darbo sritis tik skaitymui. Sąskaitą sukurkite Apskaita5 programoje.',
    readOnlyBanner: 'Ši darbo sritis tik skaitymui: formą galite užpildyti, bet išsaugoti galima tik Apskaita5 programoje. Čia sąskaita atsiras automatiškai.',
    purchasesTab: 'Pirkimai (Gautos)',
    draft: 'Juodraštis',
    post: 'Registruoti',
    client: 'Klientas',
    supplier: 'Tiekėjas',
    sum: 'Suma',
    vat: 'PVM',
    deleteTitle: 'Ištrinti sąskaitą faktūrą',
    deleteMessage: 'Ar tikrai norite ištrinti sąskaitą faktūrą #{{id}}? Šio veiksmo negalima atšaukti.',
    postTitle: 'Registruoti sąskaitą faktūrą',
    postMessage: 'Registruoti sąskaitą faktūrą #{{id}} į didžiąją knygą? Bus sukurtas žurnalo įrašas.',
    noInvoicesFound: 'Sąskaitų faktūrų nerasta',
    // Credit Note
    creditNoteTitle: 'Nauja kreditinė sąskaita faktūra',
    createCreditNote: 'Kreditinė SF',
    creatingCreditNote: 'Kuriamas kreditinis dokumentas...',
    linkedInvoice: 'Susijusi sąskaita faktūra',
    unlinkInvoice: 'Atjungti',
    searchInvoicePlaceholder: 'Ieškoti sąskaitos pagal numerį, asmenį...',
    creditNoteFor: 'Kreditinė sąskaita už',
    selectPerson: '-- Pasirinkti --',
    creditNoteContentPlaceholder: 'Kreditinės sąskaitos aprašymas...',
    invoiceDate: 'Sąskaitos data',
    documentNumber: 'Dokumento nr.',
    currencyRate: 'Valiutos kursas',
    unit: 'Vnt.',
    price: 'Kaina',
    qty: 'Kiekis',
    vatRate: 'PVM tarifas',
    lineItems: 'Eilutės',
    addLine: 'Pridėti eilutę',
    none: 'Be PVM',
    totalWithVat: 'Viso su PVM',
  },

  // Journal
  journal: {
    title: 'Žurnalas',
    newEntry: '+ Naujas įrašas',
    templates: 'Šablonai',
    source: 'Šaltinis',
    allSources: 'Visi šaltiniai',
    manualEntry: 'Rankinis įrašas',
    invoicePosting: 'Sąskaitos faktūros registras',
    bankOperation: 'Banko operacija',
    periodClosing: 'Periodo uždarymas',
    aiGenerated: 'Sugeneruota automatiškai',
    adjustment: 'Koregavimas',
    debit: 'Debetas',
    credit: 'Kreditas',
    balanced: 'Subalansuota',
    notBalanced: 'Nesubalansuota',
    unbalanced: 'NESUBALANCUOTA',
    totalDebit: 'Viso debetas',
    totalCredit: 'Viso kreditas',
    difference: 'Skirtumas',
    noJournalEntriesFound: 'Žurnalo įrašų nerasta',
    createTemplate: '+ Sukurti šabloną',
    useTemplate: 'Naudoti šabloną',
    // Journal Edit
    editEntry: 'Redaguoti žurnalo įrašą #{{id}}',
    newJournalEntry: 'Naujas žurnalo įrašas',
    documentNumber: 'Dokumento nr.',
    documentType: 'Dokumento tipas',
    content: 'Turinys',
    person: 'Asmuo',
    contentPlaceholder: 'Žurnalo įrašo aprašymas...',
    docRequired: 'Dokumento numeris yra būtinas',
    contentRequired: 'Turinys yra būtinas',
    lineWithAccountRequired: 'Būtina bent viena eilutė su sąskaita ir teigiama suma',
    everyLineMustHaveAccount: 'Kiekvienoje eilutėje su suma turi būti pasirinkta sąskaita',
    entryNotBalanced: 'Įrašas nesubalansuotas. Debetas: {{debit}}, Kreditas: {{credit}}, Skirtumas: {{difference}}',
    futureDateWarning: 'Įspėjimas: data yra ateityje.',
    noDebitLines: 'Nėra debeto eilučių',
    noCreditLines: 'Nėra kredito eilučių',
    debitTotal: 'Debetas (Debetas)',
    creditTotal: 'Kreditas (Kreditas)',
    addDebit: '+ Debetas',
    addCredit: '+ Kreditas',
    saveChanges: 'Išsaugoti pakeitimus',
    createEntry: 'Sukurti įrašą',
    // Journal Detail
    entryNotFound: 'Įrašas nerastas',
    entryDeleted: 'Žurnalo įrašas #{{id}} ištrintas',
    deleteTitle: 'Ištrinti žurnalo įrašą',
    deleteMessage: 'Visam laikui ištrinti žurnalo įrašą #{{id}}? Šio veiksmo negalima atšaukti.',
    cloneTitle: 'Duplikuoti žurnalo įrašą',
    cloneMessage: 'Sukurti žurnalo įrašo #{{id}} kopiją su šiandienos data?',
    clone: 'Duplikuoti',
    lines: 'Eilutės',
    // ADR-010 — promote a draft into the client's real book
    promoteToClientBook: 'Registruoti kliento knygoje',
    promotionSending: 'Siunčiama…',
    promotionDone: 'Įregistruota',
    promotionDoneNumber: 'Įregistruota Nr. {{id}}',
    promotionCheck: 'Patikrinti rezultatą',
    promotionRetry: 'Pakartoti',
    // Document types
    docTypeGeneric: 'Bendras',
    docTypeSalesInvoice: 'Pardavimo sąskaita faktūra',
    docTypePurchaseInvoice: 'Pirkimo sąskaita faktūra',
    docTypeBankOp: 'Banko operacija',
    docTypeCashIncome: 'Kasos pajamos',
    docTypeCashSpending: 'Kasos išlaidos',
    docTypeOffset: 'Užskaita',
    docTypeWageSheet: 'Algalapis',
    // Document type labels keyed by the select value (JournalEdit)
    docType: {
      sp: 'Įprastas įrašas',
      sf: 'Pardavimo sąskaita',
      sg: 'Pirkimo sąskaita',
      b: 'Banko operacija',
      kio: 'Kasos pajamos',
      kpo: 'Kasos išlaidos',
      sk: 'Užskaita',
      bd: 'Algų žiniaraštis',
    },
    docNumberPlaceholder: 'pvz. T-001',
    personOptional: 'Asmuo (nebūtina)',
    removeLine: 'Pašalinti eilutę',
  },

  // Settings
  settings: {
    title: 'Nustatymai',
    // Company
    companyInfo: 'Įmonės informacija',
    companyName: 'Pavadinimas',
    companyCode: 'Įmonės kodas',
    vatCode: 'PVM kodas',
    address: 'Adresas',
    headPerson: 'Vadovas',
    createCompany: 'Sukurti įmonę',
    createCompanyDescription: 'Įmonė dar nenustatyta. Užpildykite žemiau esančią formą, kad pradėtumėte.',
    // Tax rates
    taxRates: 'Mokesčių tarifai',
    addTaxRate: '+ Pridėti mokesčiio tarifą',
    rate: 'Tarifas (%)',
    vatDebitAccount: 'PVM debeto sąskaita',
    vatCreditAccount: 'PVM kredito sąskaita',
    vatPurchaseAccount: 'PVM pirkimo sąskaita',
    validFrom: 'Galioja nuo',
    noTaxRates: 'Nėra mokesčių tarifų',
    failedToCreateTaxRate: 'Nepavyko sukurti mokesčio tarifo',
    // Document serials
    documentSerials: 'Dokumentų serijos',
    manageSerials: 'Valdyti serijas',
    lastNumber: 'Paskutinis nr.',
    pattern: 'Šablonas',
    reset: 'Atstatyti',
    noDocumentSerials: 'Dokumentų serijos nesukonfigūruotos',
    // AI Agent
    aiAgentSettings: 'AI agento nustatymai',
    aiAgentDescription: 'Konfigūruoti įgaliojimų lygius kiekvienam AI darbo eigui',
    workflow: 'Darbo eiga',
    authorityLevel: 'Įgaliojimų lygis',
    aiDescription: 'Aprašymas',
    noAiWorkflows: 'AI darbo eigos nesukonfigūruotos',
    authorityAuditNote: 'Įgaliojimų pakeitimai registruojami audito žurnale. Numatytasis lygis yra „Siūlyti“, kol nepakeičiamas.',
    saveChanges: 'Išsaugoti pakeitimus ({{count}})',
    // Administration
    administration: 'Administravimas',
    docSerialsDescription: 'Valdyti dokumentų numeravimo šablonus, prievardžius ir sekas',
    userRolesPermissions: 'Vartotojų vaidmenys ir teisės',
    rolesDescription: 'Valdyti vaidmenis ir modulio lygio prieigos kontrolę',
    dataBackup: 'Atsarginė kopija',
    backupDescription: 'Eksportuoti įmonės duomenis kaip JSON atsarginės kopijos failą',
    emailConfiguration: 'El. pašto konfigūracija',
    emailDescription: 'SMTP nustatymai sąskaitų faktūrų siuntimui el. paštu',
    language: 'Kalba',
    languageDescription: 'Numatytoji sąsajos kalba — išsaugoma šioje naršyklėje ir taikoma kiekvieną kartą prisijungus',
  },

  // Accounts
  accounts: {
    title: 'Sąskaitų planas',
    trialBalance: 'Bandomasis balansas',
    newAccount: '+ Nauja sąskaita',
    accountNumber: 'Sąskaitos numeris',
    saftCode: 'SAFT kodas',
    number: 'Numeris',
    noAccounts: 'Sąskaitų nerasta',
    deleteConfirm: 'Ištrinti sąskaitą {{number}}?',
    classLabel: 'Klasė',
  },

  // Persons
  persons: {
    title: 'Kontaktai',
    subtitle: 'Bendras klientų, tiekėjų ir darbuotojų sąrašas',
    addContact: 'Pridėti kontaktą',
    total: 'Iš viso',
    customers: 'Klientai',
    vendors: 'Tiekėjai',
    employees: 'Darbuotojai',
    custVend: 'Klient+Tiek.',
    searchPlaceholder: 'Ieškoti pagal pavadinimą, kodą ar PVM kodą...',
    allContacts: 'Visi kontaktai',
    customerOnly: 'Tik klientai',
    vendorOnly: 'Tik tiekėjai',
    employeeOnly: 'Tik darbuotojai',
    custPlusVend: 'Klientas + Tiekėjas',
    hasAnyRole: 'Bet koks vaidmuo',
    receivables: 'Gautinos',
    payables: 'Mokėtinos',
    roles: 'Vaidmenys',
    noRole: 'Be vaidmens',
    both: 'Abu',
    noContacts: 'Kontaktų nerasta',
    editContact: 'Redaguoti kontaktą',
    newContact: 'Naujas kontaktas',
    receivablesAccount: 'Gautinų sąskaita',
    payablesAccount: 'Mokėtinų sąskaita',
    customer: 'Klientas',
    vendor: 'Tiekėjas',
    employee: 'Darbuotojas',
    naturalPerson: 'Fizinis asmuo',
    update: 'Atnaujinti',
    personDeleted: 'Asmuo #{{id}} ištrintas',
    deleteConfirm: 'Ištrinti {{name}}?',
    inactive: 'Neaktyvus',
    // Address fields
    street: 'Gatvė',
    city: 'Miestas',
    postalCode: 'Pašto kodas',
    country: 'Šalis',
    // Contact fields
    contactName: 'Kontaktinis asmuo',
    contactPhone: 'Telefonas',
    contactEmail: 'El. paštas',
    // Business terms
    paymentTermsDays: 'Mokėjimo terminas (dienos)',
    discountPercent: 'Nuolaida (%)',
    creditLimit: 'Kreditinis limitas',
    sector: 'Veiklos sektorius',
    notes: 'Pastabos',
  },

  // Periods
  periods: {
    closeTitle: 'Periodo uždarymas',
  },

  // Reports
  reports: {
    nav: {
      title: 'Ataskaitos',
      vat: 'PVM suvestinė',
      declaration: 'PVM deklaracija',
      financial: 'Finansinės ataskaitos',
      debtAging: 'Skolų senumas',
      cashBook: 'Kasos knyga',
      accountStatement: 'Sąskaitų išrašas',
      debtStatement: 'Suderinimo aktas',
      invoiceRegister: 'SF registras',
      close: 'Uždarymas',
      saft: 'Eksportas (SAFT)',
    },
    vatSummary: 'PVM suvestinė',
    vatDeclaration: 'PVM deklaracija',
    financialStatements: 'Finansinės ataskaitos',
    debtAging: 'Skolų senumo ataskaita',
    exportSaft: 'SAFT eksportas',
  },

  // Banking
  banking: {
    title: 'Banko operacijos',
    import: 'Banko išklotinės importas',
    importStatement: 'Importuoti išklotinę',
    newOperation: '+ Nauja operacija',
    cashOperations: 'Kasos operacijos',
    offsets: 'Užskaitos',
    inflowCredit: 'Pajamos (Kreditas)',
    outflowDebit: 'Išlaidos (Debetas)',
    netCashMovement: 'Grynasis pinigų judėjimas',
    debitAcct: 'Debeto sąsk.',
    creditAcct: 'Kredito sąsk.',
    noBankOperations: 'Šiuo laikotarpiu banko operacijų nerasta',
    editBankOperation: 'Redaguoti banko operaciją',
    newBankOperation: 'Nauja banko operacija',
    documentNumberLabel: 'Dokumento numeris *',
    amountLabel: 'Suma *',
    debitAccountLabel: 'Debeto sąskaita',
    creditAccountLabel: 'Kredito sąskaita',
    bankAccountCodeLabel: 'Banko sąskaitos kodas',
    personLabel: 'Asmuo',
    currencyLabel: 'Valiuta',
    currencyRateLabel: 'Valiutos kursas',
    updateOperation: 'Atnaujinti',
    createOperation: 'Sukurti',
    deleteOperation: 'Ištrinti operaciją',
    operationDeleted: 'Banko operacija #{{id}} ištrinta',
    reconciliationWorkspace: 'Suderinimo darbo sritis',
    reconciliationDescription: 'Banko suderinimas sugretins banko išrašo operacijas su vidiniais įrašais. Šiai funkcijai reikia sukonfigūruoti banko tiekėjo integraciją Nuostatose.',
    startReconciliation: 'Pradėti suderinimą (jau greitai)',
    selectAccount: '-- Pasirinkti --',
    selectPerson: '-- Nėra --',
    docNumberPlaceholder: 'pvz. BO-001',
    // Bank Import
    smartBankImport: 'Išmanus banko importas',
    backToBanking: 'Atgal į banką',
    total: 'Iš viso',
    highConfidence: 'Didelis pasitikėjimas',
    partialMatch: 'Dalinis atitikimas',
    noMatch: 'Atitikmens nėra',
    accepted: 'Priimta',
    totalInflow: 'Iš viso pajamos',
    totalOutflow: 'Iš viso išlaidos',
    detectedFormat: 'Aptiktas formatas',
    acceptAllGreen: 'Priimti visus žalius ({{count}})',
    acceptAll: 'Priimti visus',
    confirmOperations: 'Patvirtinti {{count}} operacijas',
    creating: 'Kuriama...',
    parseWarnings: 'Analizės įspėjimai',
    counterparty: 'Korespondentas',
    confidence: 'Pasitikėjimas',
    importComplete: 'Importas baigtas',
    created: 'Sukurta',
    skipped: 'Praleista',
    errors: 'Klaidos',
    importAnotherFile: 'Importuoti kitą failą',
    viewBankingOperations: 'Peržiūrėti banko operacijas',
    accountNumberHint: 'Jūsų banko sąskaitos numeris sąskaitų plane',
    dragAndDrop: 'Nuvilkite banko išklotinės failą čia',
    supportedFormats: 'Palaikomi formatai: CSV (SEB, Swedbank, Luminor), XML (Camt.053), MT940 (SWIFT)',
    browseFiles: 'Parinkti failą',
    pasteCsvText: 'Įklijuoti CSV tekstą',
    pasteBankStatement: 'Įklijuoti banko išklotinę',
    backToFileUpload: 'Atgal į failo įkėlimą',
    bankFormat: 'Banko formatas',
    autoDetect: 'Automatinis aptikimas',
    parseAndMatch: 'Analizuoti ir sugretinti',
    parsing: 'Analizuojama...',
    noOperations: 'Nėra operacijų',
    // Bank Accounts
    bankAccounts: 'Banko sąskaitos',
    manageAccounts: 'Valdyti sąskaitas',
    newAccount: '+ Nauja sąskaita',
    accountDeleted: 'Banko sąskaita ištrinta',
    accountUpdated: 'Banko sąskaita atnaujinta',
    accountCreated: 'Banko sąskaita sukurta',
    deleteAccountConfirm: 'Ištrinti šią banko sąskaitą?',
    accounts: 'Sąskaitos',
    balances: 'Balansai',
    statement: 'Išklotinė',
    accountName: 'Sąskaitos pavadinimas',
    bankNameCol: 'Bankas',
    glAccount: 'DK sąskaita',
    status: 'Būsena',
    active: 'Aktyvi',
    inactive: 'Neaktyvi',
    type: 'Tipas',
    noBankAccounts: 'Banko sąskaitos nesukonfigūruotos',
    totalNet: 'Grynasis balansas',
    debit: 'Debetas',
    credit: 'Kreditas',
    netBalance: 'Grynasis balansas',
    noBalances: 'Balansai neprieinami',
    openingBalance: 'Pradinis',
    periodDebit: 'Periodo debetas',
    periodCredit: 'Periodo kreditas',
    periodNet: 'Periodo skirtumas',
    closingBalance: 'Galutinis',
    noTransactions: 'Šiame periode operacijų nėra',
    selectAccountForStatement: 'Pasirinkite banko sąskaitą išklotinei peržiūrėti',
    chooseAccount: '-- Pasirinkite sąskaitą --',
    allTypes: 'Visos',
    typeBank: 'Banko sąskaita',
    typePseudo: 'Pseudo bankas',
    typeTill: 'Kasa',
    accountNameLabel: 'Sąskaitos pavadinimas',
    bankNameLabel: 'Banko pavadinimas',
    bankCodeLabel: 'Banko kodas',
    typeLabel: 'Sąskaitos tipas',
    accountType: 'Sąskaitos tipas',
    glAccountLabel: 'DK sąskaitos numeris',
    editAccount: 'Redaguoti banko sąskaitą',
    // Reconciliation
    showUnreconciled: 'Rodyti nesugretintas',
    hideUnreconciled: 'Slėpti nesugretintas',
    unreconciledCount: 'nesugretintų operacijų (-os)',
    markReconciled: 'Pažymėti sugretintą',
    allReconciled: 'Visos operacijos sugretintos!',
    reconciliationUpdated: 'Sugretinimo būsena atnaujinta',
    // Manual matching ("Rankinis derinimas")
    manualMatch: 'Rankinis derinimas',
    manualMatchMark: 'Pažymėti rankiniam derinimui',
    manualMatchRemove: 'Nuimti žymą',
    manualMatchNotePrompt: 'Kodėl reikalingas rankinis derinimas? (pvz., avansas)',
    manualMatchHint: 'Mokėjimas nebus derinamas automatiškai — jis liks Darbuose, kol suderinsite rankiniu būdu',
    manualMatchMarked: 'Operacija pažymėta rankiniam derinimui',
    manualMatchCleared: 'Žyma nuimta — automatinis derinimas atnaujintas',
    // pain.001 payment preparation (banking cycle close, 2026-09-12)
    payments: {
      link: 'Mokėjimai bankui',
      title: 'Mokėjimų paruošimas bankui',
      subtitle: 'Neapmokėtos pirkimo sąskaitos — pažymėkite, ką mokėsite, ir atsisiųskite mokėjimų failą bankui.',
      account: 'Mokėjimo sąskaita',
      chooseAccount: '— Pasirinkite sąskaitą —',
      noAccounts: 'Nėra tinkamos banko sąskaitos — pridėkite sąskaitą su IBAN (EUR) skyriuje Banko sąskaitos.',
      missingAccount: '{{count}} tiekėjas(-ai) be banko sąskaitos — jų sąskaitų čia išsiųsti negalima:',
      selectAll: 'Pažymėti viską',
      select: 'Pažymėti',
      col: {
        doc: 'Sąskaita',
        date: 'Data',
        supplier: 'Tiekėjas',
        amount: 'Neapmokėta',
      },
      empty: 'Nėra neapmokėtų pirkimo sąskaitų.',
      selected: 'Pažymėta: {{count}}',
      export: 'Eksportuoti ({{count}})',
      done: 'Mokėjimų failas atsisiųstas ({{count}} mokėjimai, {{total}}). Įkelkite jį į internetinį banką.',
    },
  },

  // AI Audit
  aiAudit: {
    title: 'AI ir auditas',
  },

  // Agent Arena
  arena: {
    title: 'Agentų arena',
    description: 'AI agentų testavimo ir varžybų aplinka.',
    comingSoon: 'Arena funkcija ruošiama. Laukite atnaujinimų.',
  },

  // Audit Trail
  audit: {
    title: 'Audito pėdsakas',
  },

  // Catalog
  catalog: {
    title: 'Prekių ir paslaugų katalogas',
  },

  // Error Boundary
  errorBoundary: {
    title: 'Kažkas nutiko',
    message: 'Programoje įvyko klaida. Bandykite perkrauti puslapį.',
    reload: 'Perkrauti',
  },

  // Confirm Dialog
  confirmDialog: {
    cancel: 'Atšaukti',
  },

  // Modules
  modules: {
    title: 'Moduliai',
    subtitle: 'Įjunkite šiai darbo sritei reikalingus pajėgumus. Apskaitos pagrindas visada įjungtas.',
    dependsOn: 'Reikalauja: {{deps}}',
    subscribed: 'Prenumerata',
    subscribedHint: 'Modulį valdo integravizija.lt prenumerata — jis įjungiamas kol prenumerata galioja.',
    sync: {
      button: 'Sinchronizuoti su prenumerata',
      hint: 'Pertraukti prenumeratų feed dabar (vyksta ir automatiškai kas 30 min bei prisijungus).',
      done: 'Prenumeratos pritaikytos — atnaujinta {{count}} darbo sričių.',
      unchanged: 'Prenumeracijų pokyčių nėra.',
    },
    advanceReports: 'Avansinės ataskaitos',
    fixedAssets: 'Ilgalaikis turtas',
    inventory: 'Atsargos',
    payroll: 'Darbo užmokestis',
  },
  // Analytics drill-down dashboard
  users: {
    title: 'Naudotojai',
    subtitle: 'Prisijungusių per integravizija.lt vaidmenys — be teisės čia niekas negali dirbti (Viewer tik skaito)',
    bridged: 'per integravizija.lt',
    local: 'vietinis',
    active: 'Aktyvus',
    inactive: 'Neaktyvus',
    empty: 'Naudotojų nėra.',
    roleChangeFailed: 'Nepavyko pakeisti vaidmens.',
    col: {
      user: 'Naudotojas',
      role: 'Vaidmuo',
      status: 'Būsena',
      lastLogin: 'Paskutinis prisijungimas',
    },
    role: {
      admin: 'Administratorius',
      senior_accountant: 'Vyr. apskaitininkas',
      accountant: 'Apskaitininkas',
      viewer: 'Stebėtojas',
    },
    hint: 'Apskaitininkas gali kurti ir redaguoti dokumentus; Stebėtojas tik peržiūri. Savo vaidmens keisti negalima — paprašykite kito administratoriaus.',
  },
  // Copilot findings triage board (/admin/findings, admin only)
  findings: {
    title: 'Užklausų vykdymas',
    empty: 'Radinių nėra.',
    worker: {
      online: 'Dev mašinka: prisijungta prieš {{seconds}} s',
      offline: 'Dev mašinka: neprisijungta',
    showClosed: 'Uždaryti ({{count}})',
    stale: 'Darbuotojas paseno — persijungia…',
    },
    deploy: {
      now: 'Deploy dabar',
      latest: 'Paskutinis darbas',
      title: 'Diegimai',
      ready: 'Paruošta diegti',
      readyEmpty: 'Naujausių pakeitimų nėra — viskas įdiegta.',
      history: 'Istorija',
      output: 'Išvestis',
    },
    col: {
      title: 'Pavadinimas',
      category: 'Kategorija',
      workspace: 'Įmonė',
      status: 'Būsena',
      priority: 'Prioritetas',
      age: 'Amžius',
      actions: 'Veiksmai',
    },
    cat: {
      ClientPattern: 'Kliento šablonas',
      ProductBug: 'Produkto klaida',
      Enhancement: 'Patobulinimas',
    },
    status: {
      Registered: 'Užregistruotas',
      Queued: 'Eilėje',
      PickedUp: 'Paimtas',
      InProgress: 'Vykdomas',
      Fixed: 'Pataisytas',
      Failed: 'Nepavyko',
      Done: 'Įdiegtas',
      Rejected: 'Atmestas',
    },
    // Auto-deploy (findings 14+15): the watch is server-owned. Marked mode
    // watches the marked set; All ships every fixed finding by itself; Off
    // disables automation.
    autoDeploy: {
      selectAll: 'Pažymėti visus automatiniam diegimui',
      mark: 'Pažymėti automatiniam diegimui',
      marked: 'Automatinis diegimas: {{count}} radiniai pažymėti',
      hint: 'Įdiegsime automatiškai, kai visi pažymėti radiniai bus pataisyti ir sistema baigs darbus.',
      waiting: 'Laukiama: {{count}} pažymėti radiniai dar nepataisyti.',
      // Mode readouts (finding 15).
      modeAll: 'Automatinis diegimas aktyvus — visi pataisyti radiniai bus įdiegti automatiškai, kai sistema bus neaktyvi.',
      modeAllWaiting: 'Laukiama: {{count}} pataisytų radinių',
      modeAllFailed: '{{count}} radinių diegimas nepavyko — žr. Progresas',
      modeOff: 'Automatinis diegimas išjungtas',
    },
    priorityUp: 'Skubiau',
    priorityDown: 'Neskubiau',
    // Sprendimai (owner review 2026-09-12): commander-flagged HIGH-risk
    // findings the owner must approve or reject before any work continues.
    decisions: {
      title: 'SPRENDIMAI',
      hint: 'Darbininkas pažymėjo, kad sprendimas rizikingas (apskaitos logika, architektūra, strategija) — kol nenuspręsite, niekas jo neima.',
      approve: 'Patvirtinti',
      reject: 'Atmesti',
    },
    queue: 'Į eilę',
    showClosed: 'Uždaryti ({{count}})',
    hideClosed: 'Rodyti tik aktyvius',
    solvedTitle: 'Išspręsta',
    reject: 'Atmesti',
    export: 'Eksportuoti',
    progressLabel: 'Progresas',
    progressAgo: 'atnaujinta prieš {{age}}',
    progressStale: 'atnaujinimų nėra — darbuotojas neprisijungęs arba darbas stringa.',
    progressEmpty: 'Progresas dar nepateiktas.',
    ageDays: '{{days}} d.',
    ageHours: '{{hours}} val.',
    actionFailed: 'Veiksmas nepavyko.',
  },
  routines: {
    title: 'Automatizavimas',
    subtitle: 'Jūs kuriate rutinas — sistema paruošia darbus iš anksto (juodraščius), o jūs patvirtinate',
    newRoutine: 'Nauja rutina',
    newTitle: 'Nauja rutina',
    editTitle: 'Redaguoti rutiną',
    active: 'Aktyvios rutinos',
    empty: 'Rutinų kol kas nėra — sukurkite pirmąją arba naudokite pasiūlymus žemiau.',
    statusActive: 'Aktyvi',
    statusPaused: 'Pristabdyta',
    kind: {
      Reminder: 'Priminimas',
      PayrollAccrual: 'DUŽ / VSD kaupimas',
      RecurringInvoice: 'Pasikartojanti sąskaita',
    },
    // Reminder-kind fields live at the routines top level — the form calls
    // t('routines.reminderType*') (they were stranded inside kind: once).
    reminderTypeLabel: 'Ką priminti',
    reminderType: {
      BankImport: 'Banko išrašo importas',
      PeriodClose: 'Periodo uždarymas',
    },
    graceDaysLabel: 'Palaukti (dienų)',
    graceDaysHint: 'Kiek dienų po laikotarpio pradžios/pabaigos duoti ramybės prieš primenant.',
    kindLabel: 'Rūšis',
    nameLabel: 'Pavadinimas',
    cadenceLabel: 'Dažnumas',
    cadence: {
      Monthly: 'kas mėnesį',
      Weekly: 'kas savaitę',
      Annually: 'kas metus',
    },
    weekdayLabel: 'Savaitės diena',
    weekday: {
      0: 'pirmadienis',
      1: 'antradienis',
      2: 'trečiadienis',
      3: 'ketvirtadienis',
      4: 'penktadienis',
      5: 'šeštadienis',
      6: 'sekmadienis',
    },
    triggerDay: 'Suveikimo diena',
    phaseLabel: 'Laikotarpis',
    phase: {
      lastMonth: 'praeito mėnesio darbas (mėnesio pabaigoje)',
      currentMonth: 'šio mėnesio darbas (suveikimo dieną)',
    },
    overdueLabel: 'Įspėti po (dienų)',
    templateLabel: 'Šablonas (JSON)',
    templateHint: 'Eilutės su sąskaitomis ir sumų būdu: Fixed / FromHistoryLast / FromHistoryAverage. Pasiūlymai užpildo automatiškai.',
    save: 'Išsaugoti rutiną',
    saveFailed: 'Nepavyko išsaugoti rutinos.',
    pause: 'Pristabdyti',
    resume: 'Aktyvuoti',
    deleteConfirm: 'Ištrinti rutiną „{{name}}“? Jos darbai nebebus ruošiami.',
    draftPosted: 'registruota',
    draftPending: 'laukia patvirtinimo',
    neverRan: 'dar nesuveikė',
    runNow: 'Paleisti dabar',
    runSummary: 'Patikrinta {{checked}} rutinų: paruošta {{premade}} juodraščių, {{alarms}} įspėjimų.',
    runFailed: 'Patikra nepavyko',
    suggestions: 'Pasiūlymai iš jūsų knygų',
    suggestionsHint: 'Sistema pastebi pasikartojančius darbus ir užpildo formą — galutinę rutiną visada kuriate jūs.',
    noSuggestions: 'Kol kas pasikartojančių darbų nepastebėta.',
    prefill: 'Užpildyti formą',
  },
  closeWizard: {
    title: 'Uždarymo vedlys',
    subtitle: 'Nuvesime per uždarymą žingsnis po žingsnio — iki tikro uždarymo įrašo',
    closeDate: 'Uždarymo data',
    annual: 'Metinis uždarymas',
    refreshing: 'Atnaujinama…',
    lastClosed: 'Paskutinis uždaryta',
    step: { overview: 'Apžvalga', cleanup: 'Duomenų sutvarkymas', dryrun: 'Bandomasis uždarymas', close: 'Metų uždarymas', achievement: 'Užbaigimas' },
    investigate: 'Klausti',
    investigateTemplate: 'Uždaru periodą {{period}}. Prieš uždarymą liko problema: {{item}}. Paaiškinkite, iš kur ji kilo ir kaip ją išspręsti. Atsakykite trumpai (iki 5 sakinių) ir nurodykite konkretų kitą žingsnį.',
    unposted: 'Neregistruotų įrašų: {{count}} — uždarymui visi turi būti užregistruoti',
    openJournal: 'Atidaryti žurnalą',
    alreadyClosed: 'Periodas {{date}} jau uždarytas',
    alreadyClosedHint: 'Vėlesniam periodui uždaryti pasirinkite vėlesnę datą.',
    dateInvalid: 'Uždarymo data turi būti vėlesnė už paskutinį uždarymą ({{last}}).',
    checklistErrorsCount: 'Priešuždarymo patikra rado {{count}} klaidą(-as) — žr. žemiau.',
    classesZero: 'Visos 5/6 klasės nulinės',
    andMore: '+ {{count}} kitos',
    continueBlocked: 'Išspręskite raudonus punktus aukščiau',
    accountsSummaryLabel: 'Balansų suvestinės sąskaita',
    accountsCurrentLabel: 'Einamojo pelno sąskaita',
    accountsFormerLabel: 'Ankstesnių metų pelno sąskaita',
    accountsPlaceholder: 'Sąskaitos nr.',
    trialBalance: 'Bandomasis balansas',
    balanced: 'Subalansuotas',
    imbalance: 'Nesbalansas: {{amount}}',
    pAndLClasses: '5/6 klasių likučiai',
    continue: 'Tęsti',
    back: 'Atgal',
    forClose: 'Būtina išspręsti iki {{date}} uždarymo',
    noChecklistIssues: 'Uždarymo kontroliniame sąraše problemų nėra',
    currentState: 'Dabartinė būklė (ne šio uždarymo dalis)',
    currentStateHint: 'Šie darbai yra apskritai apskaitoje, ne būtini šiam uždarymui — bet gera proga juos sutvarkyti.',
    toDryRun: 'Bandomasis uždarymas',
    dryRunTitle: 'Bandomasis uždarymas (nieko neįrašoma)',
    dryRunRunning: 'Skaičiuojama…',
    dryRunPassed: 'Bandomasis uždarymas pavyko — būtų sukurti {{lines}} uždarymo eilutės',
    dryRunFailed: 'Bandomasis uždarymas nepavyko',
    closingDebits: 'Uždarymo debetas',
    netResult: 'Numatomas rezultatas',
    agmSkipped: 'AGM data nepateikta — pelno perkėlimas į neatliktą pelną nebus atliktas (galima pakartoti vėliau su data).',
    warningsNeedConfirm: 'Šie įspėjimai blokuos galutinį uždarymą. Uždarymo žingsnyje galėsite tęsti tik juos patvirtinę.',
    toClose: 'Eiti prie uždarymo',
    closeTitle: 'Uždaryti periodą iki {{date}}',
    agmDate: 'Akcininkų susirinkimo data (neprivaloma)',
    agmHint: 'Jei pateikta, pelnas perliekamas į neatliktą pelną pagal VAS 4 reikalavimus.',
    manualClose: 'Rankinis uždarymas su konkrečiomis sąskaitomis',
    closeNow: 'Uždaryti dabar',
    warningsBeforeClose: 'Prieš uždarymą liko įspėjimai:',
    acknowledgeWarnings: 'Suprantu įspėjimus ir noriu tęsti uždarymą nepaisant jų',
    warningsBlockedClose: 'Uždarymą sustabdė priešuždarymo įspėjimai. Peržiūrėkite juos ir patvirtinkite tęsimą.',
    confirmTitle: 'Patvirtinti uždarymą',
    confirmMessage: 'Uždaryti periodą iki {{date}}? Po uždarymo įrašai šiame periode bus užrakinti.',
    closeFailed: 'Uždarymas nepavyko',
    forbidden: 'Uždarymui reikia administratoriaus arba vyresniojo apskaitininko teisių.',
    achievement: '{{date}} metai uždaryti',
    missingAccounts: 'Nerasta uždarymo sąskaitų — be jų uždarymas neprasidės',
    proposedAccounts: 'Pasiūlyma iš {{from}} uždarymo: balansų suvestinė {{summary}}, einamasis pelnas {{current}}, ankstesnių metų pelnas {{former}}. Patikrinkite ir nustatykite.',
    noProposal: 'Pirmasis uždarymas — istorijos nėra, iš kur pasiūlyti sąskaitas. Įveskite tris uždarymo sąskaitas pagal jūsų sąskaitų planą:',
    setAccounts: 'Nustatyti uždarymo sąskaitas',
    accountsSet: 'Uždarymo sąskaitos nustatytos',
    unpostedAfter: '{{count}} neregistruoti įrašai datuoti po uždarymo data (testiniai?) — uždarymui netrukdo, bet teršia knygą',
    whatsNext: 'Kas toliau',
    nextStatements: 'Metinė finansinė ataskaita teikiama Registrų centre (efinansinės ataskaitos).',
    nextDeclaration: 'Metinė mokesčių deklaracija teikiama VMI.',
    nextOutside: 'Šių dokumentų pateikimas kol kas ne šioje sistemoje — knygos uždarytos teisingai, dokumentus susirasite savo įprastais kanalais.',
    achievementHint: 'Sukurtas uždarymo įrašas, rezultatas perlaidotas, balansas patikrintas. Jei reikėtų ką pataisyti — periodą galima atidaryti iš naujo (atsargiai, jei ataskaitos jau pateiktos).',
    income: 'Pajamos',
    expenses: 'Sąnaudos',
    netProfit: 'Rezultatas',
  },
  invoiceTemplate: {
    title: 'Sąskaitos šablonas',
    subtitle: 'Logotipas, spalva ir apačios tekstas PDF sąskaitose',
    canvasHint: 'Spustelėkite sąskaitos elementą norėdami keisti',
    logo: 'Logotipas',
    logoUpload: 'Įkelti logotipą',
    logoRemove: 'Pašalinti logotipą',
    logoHint: 'PNG arba JPEG, iki 2 MB',
    uploading: 'Įkeliama…',
    accentColor: 'Akcento spalva',
    accentHint: 'Naudota sąskaitos antraštėje ir galutinėje sumoje',
    accentNone: 'Be spalvos',
    preset_classic: 'Klasikinis',
    preset_minimal: 'Minimalus',
    preset_modern: 'Modernus',
    showUnit: 'Rodyti matavimo vienetų stulpelį',
    hideUnit: 'Slėpti matavimo vienetų stulpelį',
    emphasizePayment: 'Paryškinti apmokėjimo rekvizitus',
    footerText: 'Tekstas sąskaitos apačioje',
    footerPlaceholder: 'pvz. Ačiū už bendradarbiavimą!',
    footerAdd: '+ Pridėti tekstą apačioje',
    preview: 'Atidaryti PDF',
    save: 'Išsaugoti',
    saving: 'Išsaugoma…',
    saved: 'Išsaugota ✓',
  },
  documents: {
    title: 'Dokumentai',
    subtitle: 'Tiekėjo sąskaitos nusiuntimas, atpažinimas ir peržiūra',
    mirrorNotice: 'Ši darbo sritis tik skaitymui. Tiekėjo sąskaitą įrašykite Apskaita5 programoje, o čia ją rasite automatiškai sinchronizuotą.',
    dropTitle: 'Įtempti arba pasirinkti tiekėjo sąskaitą (PDF, JPG, PNG iki 10 MB)',
    dropHint: 'Sąskaita atpažįstama automatiškai — viską patikrinkite prieš patvirtindami.',
    uploading: 'Įkeliama ir atpažįstama…',
    uploadFailed: 'Nepavyko įkelti arba atpažinti dokumento.',
    listTitle: 'Dokumentų sąrašas',
    empty: 'Dokumentų dar nėra.',
    selectHint: 'Pasirinkite dokumentą iš sąrašo.',
    openFile: 'Atidaryti failą',
    recognizing: 'Atpažįstama… (iki kelių minučių)',
    retry: 'Pakartoti atpažinimą',
    retrying: 'Kartojama…',
    reject: 'Atmesti',
    rejectConfirm: 'Atmesti šį skenavimą?',
    rejectedInfo: 'Skenavimas atmestas. Failas saugomas retrospektyvai.',
    confirm: 'Patvirtinti → pirkimo sąskaitos juodraštis',
    confirming: 'Kuriamas juodraštis…',
    confirmFailed: 'Nepavyko sukurti juodraštį.',
    askClient: 'Paklausti kliento apie šį dokumentą',
    askPlaceholder: 'Ką norite paklausti? (klausimas atsiras skirtuke Laukiama kliento)',
    askSend: 'Klausti',
    asked: 'Klausimas įrašytas — matomas Dėmesys → Laukiama kliento.',
    confirmHint: 'Sukuriamas NEregistruotas pirkimo sąskaitos juodraštis. Registravimas ir perkėlimas į Apskaita5 — vėlesnė versija.',
    confirmedTitle: 'Sukurtas pirkimo sąskaitos juodraštis',
    confirmedHint: 'Juodraštis neregistruotas — peržiūrėkite ir užregistruokite Pirkimuose.',
    openPurchases: 'Atidaryti Pirkimus',
    crosscheckTitle: 'Sumų atitikties patikra nepraėjo — reikšmės paliktos kaip nuskaitytos',
    nonEur: 'Sąskaita ne EUR ({{currency}}) — kol kas palaikome tik EUR.',
    needPerson: 'Pasirinkite tiekėją',
    choosePerson: 'pasirinkite tiekėją',
    serviceLine: 'Paslauga',
    totals: 'Iš viso',
    vat: 'PVM',
    f: {
      supplier: 'Tiekėjas',
      number: 'Sąskaitos nr.',
      date: 'Data',
      net: 'Suma be PVM',
      total: 'Iš viso',
      person: 'Tiekėjas įmonėje',
      content: 'Turinys',
      defaultAccount: 'Sąnaudų sąskaita',
      defaultVatAccount: 'PVM sąskaita',
    },
    col: {
      name: 'Pavadinimas',
      unit: 'Mato vnt.',
      qty: 'Kiekis',
      price: 'Kaina',
      vat: 'PVM',
      sum: 'Suma',
      account: 'Sąskaita',
      defaultAccount: '(numatytoji)',
    },
    status: {
      Uploaded: 'Įkeltas',
      Recognizing: 'Atpažįstama',
      Recognized: 'Atpažintas',
      RecognitionFailed: 'Nepavyko',
      Confirmed: 'Patvirtintas',
      Rejected: 'Atmestas',
    },
    error: {
      llm_unavailable: 'Atpažinimo servisas nepasiekiamas. Patikrinkite raktą ir bandykite dar kartą.',
      scan_failed: 'Atpažinimas nepavyko. Bandykite dar kartą.',
      mirror_read_only: 'Ši darbo sritis tik skaitymui. Sąskaitą įrašykite Apskaita5 programoje.',
      file_too_large: 'Failas per didelis (riba 10 MB).',
      unsupported_media: 'Nepalaikomas failo tipas (tik PDF, JPG, PNG).',
    },
    check: {
      triangle: 'sumos be PVM + PVM nesutampa su galutine suma',
      'net-missing': 'nenurodyta suma be PVM, nors eilučių yra',
      'lines-vs-net': 'eilučių sumos nesutampa su suma be PVM',
    },
  },
  analytics: {
    title: 'Darbai',
    loading: 'Kraunama…',
    dataAsOf: 'Duomenys atnaujinti {{time}}',
    sync: {
      title: 'Sinchronizuojami duomenys…',
      subtitle: 'Pirmasis jūsų darbo srities duomenų sinchronizavimas dar nepabaigtas. Rodikliai pasirodys iškart po jo.',
      hint: 'Nieko daryti nereikia — puslapis atsinaujins pats',
    },
    back: 'Į pradžią',
    hostedReadOnly: 'Ši darbo sritis tik skaitoma — pakeitimai atliekami Apskaita5 programoje.',
    topDebtors: 'Didžiausi skolininkai',
    tile: {
      receivables: 'Gautinos sumos',
      overdue: 'Vėluojančios gautinos',
      payables: 'Mokėtinos sumos',
      cash: 'Pinigai',
      vat: 'PVM (mėnesį)',
      findings: 'Pastebėjimai',
      debtors: 'Skolininkų: {{count}}',
      overdueShare: 'Vėluoja {{value}} visos gautinos',
    },
    inbox: {
      empty: 'Viskas tvarkoje',
      observations: 'Stebėjimai',
      observationsHint: 'Pastebėjimai, ne darbas.',
      emptyHint: 'Jokių skubių darbų.',
      runCheck: 'Paleisti patikrą',
      running: 'Tikrinama…',

        rules: {
        title: "Automatinio suderinimo taisyklės",
        empty: "Tiksliai atitinkantys mokėjimai suderinami automatiškai (visada). Papildomų taisyklių nėra.",
        disable: "Išjungti",
        timesUsed: "naudota {{count}}×",
        stopAuto: "Nebe automatizuoti šiam klientui",
        toastHint: "Galite bet kada išjungti per 🤖 Auto mygtuką.",
        },
      overdueBy: 'vėluoja {{days}} d.',
      journey: {
        filterOff: '{{year}} m. darbų filtras',
        filterBy: 'Filtruoti darbus: {{year}} m.',
        filterActive: 'rodoma {{shown}} iš {{total}} darbų',
        filterEmpty: '{{year}} m. darbų nėra.',
        title: 'Finansiniai metai',
        refreshing: 'Atnaujinama…',
        closedAt: 'Uždaryta {{date}}',
        showAll: 'Rodyti visus metus',
        showRelevant: 'Rodyti tik aktualius',
      },
      case: {
        title: 'Darbas',
        stickyBadge: 'Laukia sprendimo',
        close: 'Uždaryti',
        backToCase: 'Atgal prie darbo',
      },
    postponedEmpty: 'Niekas neatidėta — visi darbai kaip įprasta.',
    postponedSoon: 'grįžta po {{days}} d.',
      doneToday: 'Atlikta šiandien: {{count}}',
      tabs: {
        darbai: 'Darbai',
        waiting: 'Laukiama kliento',
        postponed: 'Atidėta',
        cases: 'Atvejai',
        auto: 'Atlikta',
      },
      card: {
        what: 'Kas',
        where: 'Kur',
        how: 'Kaip',
        toInvoice: 'Sąskaita',
        toJournal: 'Įrašas',
        toPerson: 'Klientas',
        clientHistory: 'Visi pavedimai / sąskaitos',
        clientHistoryHint: 'Rodyti visas šio kliento sąskaitas ir pavedimus — ir apmokėtas, ir neapmokėtas',
        investigate: 'Klausti',
        askClient: 'Klausti kliento',
        done: 'Atlikta',
        postpone: 'Atidėti',
        postponeUntil: 'Atidėti iki',
        postponeConfirm: 'Atidėti',
        notProblem: 'Ne problema',
        finishGroup: 'Baigti darbą',
            status: {
        label: 'Būsena…',
        apply: 'Patvirtinti',
      },
        declinePlaceholder: 'Kodėl tai nėra problema?',
        docNotFound: 'Dokumentas {{token}} nerastas.',
        commentLabel: 'Komentaras (nebūtina)',
        dayEarlier: 'Diena anksčiau',
        dayLater: 'Diena vėliau',
        askPlaceholder: 'Ką paklausti kliento apie šį įrašą?',
        askSend: 'Klausti',
        asked: 'Klausimas įrašytas (Dėmesys → Laukiama kliento)',
        actionFailed: 'Veiksmas nepavyko.',
        confirmAndPost: 'Patvirtinti ir registruoti',
        catchUp: 'Sugrąžinti praleistus ({{count}})',
        confirmAll: 'Patvirtinti visus',
        openWizard: 'Atidaryti uždarymo vedlį',
        openBankImport: 'Atidaryti banko importą',
        confirmFailed: 'Nepavyko užregistruoti juodraščio.',
        askTemplate: 'Ištirkite darbo elementą: {{title}}. {{ids}}. Paaiškinkite, kas negerai, ir pasiūlykite, kaip tai išspręsti. Atsakykite trumpai (iki 5 sakinių) ir nurodykite konkretų kitą žingsnį.',
        askJournal: 'žurnalo įrašas #{{id}}',
        askInvoice: 'sąskaita #{{id}}',
        askPerson: 'klientas #{{id}}',
        createRule: 'Sukurti taisyklę',
        ruleValueLabel: 'Reikšmė',
        ruleFieldLabel: 'Taisyklės tipas',
        ruleFieldDocumentPrefix: 'Dokumento nr. prasideda',
        ruleFieldSenderContains: 'Siuntėjo vardas turi',
        ruleCreated: 'Taisyklė sukurta — tokie pavedimai nebebus žymimi',
      },
      atlikta: {
        ManualDone: 'Atlikta',
        Declined: 'Ne problema',
        Postponed: 'Atidėta',
        restore: 'Grąžinti',
      },
      tabsEmpty: {
        waiting: 'Kol kas niekas nelaukia kliento atsakymo.',
        waitingHint: 'Čia atsiras klausimai klientui, trūkstami dokumentai ir patvirtinimai, kai klientų portalas bus pajungtas.',
        cases: 'Aktyvių atvejų nėra.',
        casesHint: 'Čia kaupsis tyrimai — neaiškios operacijos, mokesčių klausimai, konsultacijos — kai pradėsime juos registruoti.',
        auto: 'Sistema kol kas nieko neužbaigė automatiškai.',
        autoHint: 'Tiksliai sutampantys mokėjimai bus suderinami automatiškai ir rodomi čia su įrodymais.',
      },
      waiting: {
        newQuestion: 'Naujas klausimas klientui',
        kind: {
          Question: 'Klausimas',
          MissingDocument: 'Reikia dokumento',
          Approval: 'Patvirtinimas',
        },
        asked: 'paklausta',
        due: 'laukiama iki',
        document: 'Dokumentas',
        answerPlaceholder: 'Kliento atsakymas (įrašykite, kai atsakys)…',
        saveAnswer: 'Įrašyti atsakymą',
        cancelRequest: 'Atšaukti',
        textPlaceholder: 'Ką norite paklausti kliento?',
        ask: 'Klausti',
      },

      cat: {
        Deadline: 'Terminas',
        OverdueInvoice: 'Skola',
        UnmatchedPayment: 'Mokėjimas',
        PayrollAccrual: 'Atlyginimas',
        Finding: 'Pastebėjimas',
      },
      col: {
        category: 'Kategorija',
        title: 'Kas',
        amount: 'Suma',
        due: 'Terminas',
        age: 'Amžius',
      },
    },
    aging: {
      title: 'Gautinų senumas',
      titlePayable: 'Mokėtinų senumas',
      ariaLabel: 'Gautinų senumo juosta',
      current: 'Ne vėluoja',
      range: '{{from}}–{{to}} d.',
      over90: '90+ d.',
      b1: '1–30 d.',
      b31: '31–60 d.',
      b61: '61–90 d.',
      empty: 'Nėra gautinų',
    },
    problems: {
      title: 'Aptiktos problemos',
      empty: 'Problemų nerasta',
      lastRun: 'Paskutinis patikrinimas',
    },
    fact: {
      receivablesTotal: 'Gautinos iš viso: {{value}}',
      overdueTotal: 'Vėluoja: {{value}}',
      overdueSharePct: 'Vėluojančių dalis: {{value}}',
      debtorsCount: 'Skolininkai: {{value}}',
      top3SharePct: 'Top 3 klientai — {{value}} gautinų',
      over90Total: 'Seniau nei 90 d.: {{value}}',
      over90SharePct: '90+ d. dalis: {{value}}',
      payablesTotal: 'Mokėtinos: {{value}}',
      cashTotal: 'Pinigai: {{value}}',
      vatNetPayableMonth: 'PVM šį mėnesį: {{value}}',
    },
    nl: {
      placeholder: 'Klauskite natūraliai: „skolingi daugiau nei 1000“…',
      go: 'Tirti',
      thinking: 'Analizuoju…',
      fallback: 'Nepavyko išaiškinti užklausos — ieškoma kaip tekstą',
    },
    explain: {
      title: 'Paaiškinimas',
      button: 'Paaiškinti',
      loading: 'Aiškinu…',
    },
    view: {
      inbox: 'Dėmesio reikalauja',
      overview: 'Apžvalga',
      customers: 'Skolininkai',
      customer: 'Klientas',
      invoice: 'Sąskaita',
      journal: 'Žurnalo įrašas',
      findings: 'Pastebėjimai',
      bank: 'Pinigai',
      vat: 'PVM',
    },
    journal: {
      total: 'Iš viso debetu',
      lines: 'Įrašo eilutės',
      debit: 'Debetas',
      credit: 'Kreditas',
      noLines: 'Eilučių nėra',
      entryTile: 'Įrašas žurnale',
    },
    customer: {
      debt: 'Gautina',
      turnoverDebit: 'Debetu apyvarta',
      turnoverCredit: 'Kreditu apyvarta',
      invoices: 'Sąskaitų',
      invoicesList: 'Kliento pardavimų sąskaitos',
      invoicesListScope: '(visos — ir apmokėtos, ir neapmokėtos)',
      paymentsList: 'Kliento pavedimai',
      noPayments: 'Pavedimų nėra',
      editPerson: 'Redaguoti kontaktą',
      noInvoices: 'Šiam klientui per pastaruosius 5 metus sąskaitų nerasta',
    },
    invoice: {
      settleFailed: 'MOKĖJIMAS NESUDERINTAS — bandykite dar kartą',

      0: "i",

      1: "n",

      2: "v",

      3: "o",

      4: "i",

      5: "c",

      6: "e",
      settle: "Suderinti",
    teachTitle: "Kitą kartą daryti automatiškai?",
    teachBody: "Šio kliento mokėjimus, atitinkančius sąskaitas (±5%), suderinsime be papildomo patvirtinimo.",
            settleConfirmTitle: "Suderinti mokėjimą su sąskaita?",
      settleConfirmBody: "Bus patvirtintas mokėjimo ir sąskaitos ryšys (suderinimas). Atskiras žurnalo įrašas nėra kuriamas.",
      settleConfirmHint: "Ryšį vėliau galima peržiūrėti ir panaikinti.",
      matchesTitle: 'Galimi atitinkantys mokėjimai',
      noMatches: 'Atitinkančių mokėjimų nerasta',
      delta: 'Skirtumas',
      journalFallback: "Sąskaita rodoma kaip žurnalo įrašas (nėra atskiro sąskaitos įrašo).",
      notFound: "Sąskaita nerasta.",
      doc: 'Sąskaita faktūra',
    },
    bank: {
      openFull: 'Visi banko išrašai',
    },
    vat: {
      salesVat: 'Pardavimų PVM',
      purchaseVat: 'Pirkimų PVM',
      net: 'Mokėtinas grynas PVM',
      openFull: 'Atidaryti pilną PVM ataskaitą',
    },
    col: {
      total: 'Iš viso',
      amount: 'Suma',
      balance: 'Likutis',
      docNo: 'Dokumento nr.',
      content: 'Turinys',
      time: 'Laikas',
      scanner: 'Skaneris',
      severity: 'Sunkumas',
      title: 'Pavadinimas',
      account: 'Sąskaita',
    },
    table: {
      rows: 'įrašų',
      clearFilters: 'šalinti filtrus',
      empty: 'Įrašų nėra',
      loading: 'Kraunama…',
      next: 'Kitas',
    },
    ask: {
      link: 'Klausti',
      title: 'Klausti',
      subtitle: 'Ko norėtumėte sužinoti apie savo finansus?',
      hint: 'Klauskite natūraliai — atsakymą pamatysite vaizdais, kuriais galėsite kasti giliau.',
      placeholder: 'Klauskite apie gautinas, skolas, mokėjimus…',
      send: 'Siųsti',
      // Secure-chat notice (finding 13): visible lock + short label, full
      // reassurance on hover (tooltip) + the Privatumas page. The always-visible
      // egress tail was removed by owner decision (2026-09-11).
      secureLabel: 'Saugus pokalbis',
      secureTooltip:
        'Jūsų finansiniai duomenys apdorojami saugiai, laikantis duomenų apsaugos ir privatumo reikalavimų. Jie nėra saugomi ar naudojami DI modeliams mokyti.',
      starter1: 'Ką reikia žinoti apie gautinas sumas?',
      starter2: 'Kas vėluoja daugiausiai?',
      starter3: 'Ar yra nesuderintų mokėjimų?',
      starter4: 'Kokia finansinė padėtis šį mėnesį?',
      statusFetching: 'Renku duomenis…',
      statusComposing: 'Renku atsakymą…',
      errorText: 'Atsakymo nepavyko sudaryti.',
      retry: 'Pakartoti',
      cardBack: 'Atgal',
      conversation: 'Pokalbis',
      expand: 'Išskleisti pokalbį',
      collapse: 'Suskleisti pokalbį',

      viewArriving: 'Renku vaizdą…',

      lockedTitle: 'Šioje darbo srityje atsakymai išjungti',
      caseBanner: 'Tiriamas darbas',
      backToCase: 'Grįžti prie darbo',
      lockedBody: 'Darbo srities savininkas neleidžia siųsti duomenų pokalbiui. Deterministinis skydelis veikia kaip visada.',
      dashboardLink: 'Atidaryti skydelį',
    },
  },
  darbai: {
    title: "Darbo eilė",
    summary: "{{companies}} įmonės · {{items}} reikalauja dėmesio",
    allClear: "Visos įmonės tvarkoje",
    allClearHint: "Jokių terminų, skolų ar nesuderintų mokėjimų.",
    companyClear: "viskas tvarkoje ✓",
    companyAttention: "{{count}} reikalauja dėmesio",
    queueTitle: "Eilė per visas įmones",
  },
  // Sodros deklaracijos (SAM / 1-SD / 2-SD)
  sodra: {
    link: 'Deklaracijos',
    title: 'Sodros deklaracijos',
    subtitle: 'SAM (mėnesinė), 1-SD (priėmimai), 2-SD (atleidimai) — iš žiniaraščių ir sutarčių įvykių.',
    type: { SAM: 'SAM (mėnesinė)', SD1: '1-SD (priėmimai)', SD2: '2-SD (atleidimai)', SD12: '12-SD (nedraudiminiai)' },
    year: 'Metai',
    month: 'Mėnuo',
    from: 'Nuo',
    to: 'Iki',
    generate: 'Generuoti',
    save: 'Išsaugoti (juodraštis)',
    income: 'Pajamos',
    payments: 'Įmokos',
    persons: 'asm.',
    sd2AccrualHint: 'Sumos pagal {{year}}-{{month}} mėn. žiniaraščius (accrual)',
    empty: 'Kol kas nėra išsaugotų deklaracijų.',
    approve: 'Patvirtinti',
    lock: 'Užrakinti',
    status: { Draft: 'Juodraštis', UnderReview: 'Peržiūrima', Approved: 'Patvirtinta', Locked: 'Užrakinta' },
    col: {
      form: 'Forma', period: 'Laikotarpis', status: 'Būsena', people: 'Žmonės',
      code: 'Asmens kodas', name: 'Vardas pavardė', income: 'Pajamos',
      payment: 'Įmokos', rate: 'Tarifas %', startDate: 'Draudimo pradžia',
      endDate: 'Draudimo pabaiga', subtype: 'Sutarties tipas',
    },
  },
  // Copilot pending-write confirmation card + chat error fallbacks
  copilotConfirm: {
    title: 'Reikalingas patvirtinimas',
    approve: 'Patvirtinti',
    decline: 'Atmesti',
    expiresIn: 'galioja dar {{seconds}} s',
    waitingHint: 'Veiksmas bus atliktas jūsų vardu.',
    executing: 'Vykdoma...',
    cancelling: 'Atšaukiama...',
    approved: 'Patvirtinta.',
    declinedMessage: 'Atmesta.',
    expired: 'Šis patvirtinimas nebegalioja.',
    errorLabel: 'Klaida',
    emptyReplyFallback: 'Atsakymo nepavyko paruošti. Pakartokite klausimą.',
  },
};

export default lt;
export type TranslationKeys = typeof lt;
